import * as React from "react";
import { useCanEditProgrammeClaim } from "../../core/auth/authorise";

const CanEditProgramme: React.FunctionComponent<any> = props => {
  const canEdit = useCanEditProgrammeClaim(props.programmeId);
  return canEdit ? props.children : null;
};

export { CanEditProgramme };
